var React = require('react');

function MailSquare (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.5133 1.9987C17.5133 1.08203 16.7633 0.332031 15.8467 0.332031H2.51335C1.59668 0.332031 0.84668 1.08203 0.84668 1.9987V11.9987C0.84668 12.9154 1.59668 13.6654 2.51335 13.6654H15.8467C16.7633 13.6654 17.5133 12.9154 17.5133 11.9987V1.9987ZM15.8467 1.9987L9.18001 6.15703L2.51335 1.9987H15.8467ZM15.8467 11.9987H2.51335V3.66536L9.18001 7.83203L15.8467 3.66536V11.9987Z"}));
}

MailSquare.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14"};

module.exports = MailSquare;

MailSquare.default = MailSquare;
